import request from '@/libs/request'

// 提现列表
export function withdrawList (data) {
  return request({
    url: `withdraw/list`,
    method: 'get',
    params: data
  })
}

// 审核通过
export function confirms (data) {
  return request({
    url: `withdraw/confirm`,
    method: 'post',
    data: data
  })
}
